export enum WidgetType {
  Amazon = 'amazon',
  Idealo = 'idealo',
  Cameras = 'cameraDatasheet',
  LocalShop = 'localShop',
  Dk = 'dkShop',
  WorkShop = 'workshop'
}
export enum Position {
  Center = 'center',
  Side = 'side'
}